import { useQuery } from 'react-query';
import getRequestInvitationHours from '../requests/getRequestInvitationHours';
import { queryKeys } from './queryKeys';

const useRequestInvitationHours = (data, options = {}, errMsg) => {
  return useQuery(
    queryKeys.requestInvitationHours(data),
    () => getRequestInvitationHours(data, errMsg),
    options
  );
};

export default useRequestInvitationHours;
